/**
 * アプリケーション環境変数の一元管理モジュール
 *
 * import.meta.env への直接参照は以下の2ファイルのみに限定する:
 * - src/config/env.ts（本ファイル）: API、Google Maps、デバッグ設定
 * - src/config/firebase.ts: Firebase SDK 設定（VITE_FIREBASE_* 系6変数）
 *
 * Firebase設定を本モジュールに統合しない理由:
 * firebase.ts は initializeApp() に直接渡す構造であり、
 * AppConfig 経由にするとモジュール初期化順序の問題が生じるため。
 */

interface ApiConfig {
  baseUrl: string;
}

interface GoogleMapsConfig {
  apiKey: string;
}

interface DebugConfig {
  fieldStateUi: boolean;
}

interface AppConfig {
  api: ApiConfig;
  googleMaps: GoogleMapsConfig;
  debug: DebugConfig;
}

function loadConfig(): AppConfig {
  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8081/api/v1';

  const googleMapsApiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
  if (!googleMapsApiKey) {
    console.error('[AppConfig] VITE_GOOGLE_MAPS_API_KEY が未設定です');
  }

  const debugFieldStateUi = import.meta.env.VITE_DEBUG_FIELD_STATE_UI === 'true';

  return {
    api: {
      baseUrl: apiBaseUrl,
    },
    googleMaps: {
      apiKey: googleMapsApiKey || '',
    },
    debug: {
      fieldStateUi: debugFieldStateUi,
    },
  };
}

/** アプリケーション設定のシングルトンインスタンス */
export const appConfig: AppConfig = loadConfig();
